import { Money3Directive } from 'v-money3';

export default defineNuxtPlugin(nuxtApp => {
// Doing something with nuxtApp
    nuxtApp.vueApp.directive('money', Money3Directive)
})